/**
 * Email format that we treat as a Clipboard Health employee account for the
 * purpose of routing between employee and facility login flows.
 *
 * - Local part must NOT contain `+` (excludes Gmail-style aliases like
 *   `user+alias@clipboardhealth.com`, which are not valid employee
 *   accounts even though they end with the company domain).
 * - Domain must be exactly `clipboardhealth.com` (case-insensitive).
 * - The `_3p@clipboardhealth.com` vendor-bypass suffix is also excluded —
 *   those are third-party vendor accounts that must not route through the
 *   employee path.
 *
 * Single source of truth for SSO mode resolution, the legacy magic-link
 * employee/facility split, and Cognito session hydration. Keep these in
 * sync so an aliased employee email doesn't get treated as an employee
 * by some flows and a non-employee by others.
 */
const CBH_EMPLOYEE_EMAIL_REGEX = /^[^+]+@clipboardhealth\.com$/i;
const VENDOR_BYPASS_SUFFIX = "_3p@clipboardhealth.com";

export function isCbhEmployeeEmail(email: string): boolean {
  const trimmed = email.trim();
  return (
    CBH_EMPLOYEE_EMAIL_REGEX.test(trimmed) && !trimmed.toLowerCase().endsWith(VENDOR_BYPASS_SUFFIX)
  );
}
